// Re-export from refactored module for backwards compatibility
export { CustomPortfolioBuilder } from "./custom-portfolio-builder/custom-portfolio-builder";
export type {
  ComponentStyleType,
  CustomPortfolioBuilderProps,
  CustomProduct,
  ProductItem,
  ProductTypeOption,
  SuitabilityStatus,
} from "./custom-portfolio-builder/custom-portfolio-builder-types";
